import { useEffect } from 'react'
import { startAutoPlayInterval, stopAutoPlayInterval } from '../../actions/room'
import { FloaterSize } from '../../constants/floaters'
import { isLounge } from '../../mfcLogic/userProperties/user'
import {
    useDialogSelector,
    useDrawerSelector,
    useFloatingRoomStateSelector,
} from './useModal'
import { useModelsLoadedAppState } from './useModelsLoadedAppState'

export const useLoungeAutoplay = (loungeId: number) => {
    const lounge = isLounge(loungeId)
    const isDrawerOpen = useDrawerSelector('show')
    const isDialogOpen = useDialogSelector('show')
    const floatingRoomSize = useFloatingRoomStateSelector('size')
    const modelsLoaded = useModelsLoadedAppState()
    const stopAutoplay =
        !lounge ||
        !loungeId ||
        isDialogOpen ||
        isDrawerOpen ||
        !modelsLoaded ||
        floatingRoomSize < FloaterSize.Fullscreen

    useEffect(() => {
        if (stopAutoplay) {
            return stopAutoPlayInterval
        }
        return startAutoPlayInterval(loungeId)
    }, [loungeId, stopAutoplay])
}
